import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import MainPanel from "../Layout/MainPanel";
import styled from "styled-components";
import { Grid, TableRow } from "@material-ui/core";
import axios from "axios";
import APIModel from "../../Models/APIModel";
import {
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableBody,
  Paper,
} from "@mui/material";
import Loader from "react-loader-spinner";

function AdminDashboard() {
  // states
  let token = localStorage.getItem("Token");
  let user_status = localStorage.getItem("status");
  const [selectedTab, setSelectedTab] = useState("revenue");
  const [selectedTabData, setSelectedTabData] = useState({});
  const [datagot, setDataGot] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    total_estimate: 0,
    total_invoice: 0,
    total_revenue: 0,
  });
  // effects
  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    setDataGot(false);
    getTableData();
  }, [selectedTab]);

  // functions

  const getTableData = () => {
    axios
      .get(APIModel.HOST + `get-${selectedTab}-data`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setSelectedTabData(res.data);
        setTimeout(() => {
          setDataGot(true);
        }, 100);
      })
      .catch((err) => console.log(err));
  };

  const formatCurrency = (number) => {
    return parseFloat(number).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  };

  const getDashboardData = () => {
    axios
      .get(APIModel.HOST + "get-dashboard-data", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setDashboardData(res.data);
      })
      .catch((err) => console.log(err));
  };

  const onTabClick = (value) => {
    if (value !== selectedTab) setSelectedTab(value);
  };

  const DivDashBoardItem = styled.div`
    background-color: ${(props) => (props.selected ? "#FC3538" : "white")};
    padding: 20px 10px 20px 10px;
    color: ${(props) => (props.selected ? "white" : "black")};
    border-radius: 5px;
    box-shadow: 2px 2px 10px 0 rgb(0 0 0 / 16%);
    width: 95%;
    margin: 15px auto;
    cursor: pointer;
    font-size: 14px;
    min-height: 180px;
    img {
      width: 75px;
      margin-left: 15px;
    }
    .heading {
      font-weight: 700;
      letter-spacing: 1.5px;
      color: ${(props) => (props.selected ? "white" : "#FC3538")};
    }
    .dsvg {
      stroke: ${(props) => (props.selected ? "white" : "#FC3538")};
    }
    .pro {
      margin-left: 5px;
      padding: 0px;
      background-color: #484adf;
      color: white;
      font-weight: lighter;
      font-size: 10px;
    }
    .elite {
      color: #484adf;
      font-weight: lighter;
      font-weight: lighter;
      font-size: 9px;
    }
    .content {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.15px;
      color: #8b8a88;
      color: ${(props) => (props.selected ? "white" : "black")};
      .first {
        color: #fc3538;
      }
      .first {
        color: ${(props) => (props.selected ? "white" : "#FC3538")};
      }
    }
  `;

  const DivLoader = styled.div`
    text-align: center;
  `;

  const Revenue = ({ selectedTabData }) => {
    const tableHead = ["Year", "Revenue"];
    return (
      <>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: "500px" }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow style={{ backgroundColor: "#FC3538" }}>
                {tableHead.map((item, index) => {
                  return (
                    <TableCell style={{ color: "white" }} key={index}>
                      {item}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
                <TableCell>{selectedTabData.year}</TableCell>
                <TableCell>${formatCurrency(selectedTabData.total)}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTabData.months !== undefined
                ? selectedTabData.months.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        {item.month_name}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.total)}
                      </TableCell>
                    </TableRow>
                  );
                })
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  const Estimate = ({ selectedTabData }) => {
    const tableHead = ["Year", "Issued", "Pending", "Approved", "Declined"];
    return (
      <>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: "500px" }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow style={{ backgroundColor: "#FC3538" }}>
                {tableHead.map((item, index) => {
                  return (
                    <TableCell style={{ color: "white" }} key={index}>
                      {item}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
                <TableCell>{selectedTabData.year}</TableCell>
                <TableCell>{+selectedTabData.issued}</TableCell>
                <TableCell>${formatCurrency(selectedTabData.pending)}</TableCell>
                <TableCell> ${formatCurrency(selectedTabData.approved)}</TableCell>
                <TableCell>${formatCurrency(selectedTabData.declined)}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTabData.month_vise !== undefined
                ? selectedTabData.month_vise.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        {item.month_name}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        {+item.issued}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.pending)}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.approved)}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.declined)}
                      </TableCell>
                    </TableRow>
                  );
                })
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  const Invoice = ({ selectedTabData }) => {
    const tableHead = ["Year", "Issued", "Paid", "Unpaid"];
    return (
      <>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: "500px" }}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow style={{ backgroundColor: "#FC3538" }}>
                {tableHead.map((item, index) => {
                  return (
                    <TableCell style={{ color: "white" }} key={index}>
                      {item}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
                <TableCell>{selectedTabData.year}</TableCell>
                <TableCell>{+selectedTabData.issued}</TableCell>
                <TableCell>${formatCurrency(selectedTabData.paid)}</TableCell>
                <TableCell>${formatCurrency(selectedTabData.unpaid)}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTabData.month_vise !== undefined
                ? selectedTabData.month_vise.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        {item.month_name}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        {+item.issued}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.paid)}
                      </TableCell>
                      <TableCell style={{ color: "rgba(0,0,0,0.65)" }}>
                        ${formatCurrency(item.unpaid)}
                      </TableCell>
                    </TableRow>
                  );
                })
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <Grid container>
                  <Grid item md={4} sm={12} xs={12}>
                    <DivDashBoardItem
                      className="px-3"
                      onClick={() => onTabClick("revenue")}
                      selected={selectedTab === "revenue"}
                    >
                      <div className="mb-3 heading d-flex justify-content-between align-items-center">
                        <h4 className="mb-0 font-weight-bold">REVENUE</h4>
                        {/* <span className="pro"> PRO</span>
                                              <span className="elite"> Elite</span> */}
                        <div className="dsvg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-cash"
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <rect x="7" y="9" width="14" height="10" rx="2" />
                            <circle cx="14" cy="14" r="2" />
                            <path d="M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2" />
                          </svg>
                          {/* <img style={{ width: '40px' }} src={process.env.PUBLIC_URL + '/icon1.png'} alt="icon1"/> */}
                        </div>
                      </div>
                      <Grid container>
                        <Grid item sm={12}>
                          <div className="content">
                            <span className="first"> ${formatCurrency(dashboardData.total_revenue)} </span>{" "}
                            <span className="text-dar">
                              received in payments for november
                            </span>
                          </div>
                        </Grid>
                      </Grid>
                    </DivDashBoardItem>
                  </Grid>
                  <Grid item md={4} sm={12} xs={12}>
                    <DivDashBoardItem
                      className="px-3"
                      onClick={() => onTabClick("estimate")}
                      selected={selectedTab === "estimate"}
                    >
                      <div className="mb-3 heading d-flex justify-content-between align-items-center">
                        <h4 className="mb-0 font-weight-bold">ESTIMATES</h4>
                        <div className="dsvg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-files"
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M15 3v4a1 1 0 0 0 1 1h4" />
                            <path d="M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z" />
                            <path d="M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2" />
                          </svg>
                        </div>
                        {/* <span className="pro"> PRO</span>
                                              <span className="elite"> Elite</span> */}
                      </div>
                      <Grid container>
                        <Grid item sm={12}>
                          <div className="content">
                            <span className="first"> ${formatCurrency(dashboardData.total_estimate)} </span>{" "}
                            <span>
                              is your Average Closing Ratio for the last 12
                              Months
                            </span>
                          </div>
                        </Grid>
                        {/* <Grid item md={4} sm={4} xs={4}>
                                          <img src={process.env.PUBLIC_URL + '/icon2.png'} alt="icon2"/>
                                      </Grid> */}
                      </Grid>
                    </DivDashBoardItem>
                  </Grid>

                  <Grid item md={4} sm={12} xs={12}>
                    <DivDashBoardItem
                      className="px-3"
                      onClick={() => onTabClick("invoice")}
                      selected={selectedTab === "invoice"}
                    >
                      <div className="mb-3 heading d-flex justify-content-between align-items-center">
                        <h4 className="mb-0 font-weight-bold">INVOICES</h4>
                        <div className="dsvg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-checkbox"
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <polyline points="9 11 12 14 20 6" />
                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                          </svg>
                        </div>
                        {/* <span className="pro"> PRO</span>
                                      <span className="elite"> Elite</span> */}
                      </div>
                      <Grid container>
                        <Grid item sm={12}>
                          <div className="content">
                            <span className="first"> ${formatCurrency(dashboardData.total_invoice)} </span>{" "}
                            <span>
                              is your total Invoiced Volume for the Month
                            </span>
                          </div>
                        </Grid>
                        {/* <Grid item md={4} sm={4} xs={4}>
                                          <img src={process.env.PUBLIC_URL + '/icon3.png'} alt="icon3"/>
                                      </Grid> */}
                      </Grid>
                    </DivDashBoardItem>
                  </Grid>
                </Grid>
                <br />
                {datagot ? (
                  selectedTab === "revenue" ? (
                    <Revenue selectedTabData={selectedTabData} />
                  ) : selectedTab === "estimate" ? (
                    <Estimate selectedTabData={selectedTabData} />
                  ) : selectedTab === "invoice" ? (
                    <Invoice selectedTabData={selectedTabData} />
                  ) : (
                    ""
                  )
                ) : (
                  <DivLoader>
                    <Loader
                      type="Oval"
                      color="#FC3538"
                      height={50}
                      width={50}
                    />
                  </DivLoader>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default AdminDashboard;
